import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { SignInLoadingScreen } from '@/features/auth/components/signInLoadingScreen';
import { completeRiotSignInWithRetry } from '@/features/auth/hooks/useCompleteRiotSignIn/useCompleteRiotSignIn.options';
import { clearAttribution, getAttribution } from '@/shared/utils/attribution';
import { sleep } from '@/shared/utils/promise';

const MIN_LOADING_DURATION_MS = 5000;

const searchSchema = z.object({
  error: z.string().optional(),
  error_description: z.string().optional(),
});

export const Route = createFileRoute('/oauth/callback')({
  validateSearch: searchSchema,
  component: () => null,
  pendingComponent: SignInLoadingScreen,
  beforeLoad: ({ search }) => {
    if (search.error) {
      throw redirect({
        to: '/login',
        search: {
          error: search.error,
          error_description: search['error_description'],
        },
        replace: true,
      });
    }
  },
  loader: async () => {
    const attribution = getAttribution();
    try {
      // Ensure loading screen shows for at least MIN_LOADING_DURATION_MS
      await Promise.all([
        completeRiotSignInWithRetry(attribution),
        sleep(MIN_LOADING_DURATION_MS),
      ]);
      clearAttribution();
    } catch {
      throw redirect({ to: '/login', replace: true });
    }
    throw redirect({ to: '/onboarding', replace: true });
  },
});
